import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { useT } from '../i18n/useT';
import { useLanguage } from '../i18n/LanguageContext';
import './FeaturesPage.css';

export default function SupportPage() {
  const t = useT();
  const { lang } = useLanguage();
  const p = t.pages.support;

  const SUPPORT_TOPICS = [
    {
      icon: '⚡',
      title: lang === 'de' ? 'Erste Schritte' : 'Getting Started',
      desc: lang === 'de' ? 'Konto einrichten, erstes Dokument scannen und die Grundlagen erlernen.' : 'Set up your account, scan your first document, and learn the basics.',
      link: '/faq',
    },
    {
      icon: '🔒',
      title: lang === 'de' ? 'Datenschutz & Sicherheit' : 'Privacy & Security',
      desc: lang === 'de' ? 'Erfahre, wie wir deine Daten schützen und deine Datenschutzeinstellungen verwaltest.' : 'Learn about how we protect your data and manage your privacy settings.',
      link: '/privacy',
    },
    {
      icon: '🖥️',
      title: lang === 'de' ? 'Technische Probleme' : 'Technical Issues',
      desc: lang === 'de' ? 'Scanprobleme, Sync-Fehler oder App-Abstürze beheben.' : 'Troubleshoot scanning problems, sync issues, or app crashes.',
      link: '/contact',
    },
    {
      icon: '📊',
      title: lang === 'de' ? 'Konto & Daten' : 'Account & Data',
      desc: lang === 'de' ? 'Daten exportieren, Konto löschen oder Dateien übertragen.' : 'Export your data, delete your account, or transfer files.',
      link: '/data-deletion',
    },
    {
      icon: '📄',
      title: lang === 'de' ? 'Dokumente & Export' : 'Documents & Export',
      desc: lang === 'de' ? 'PDFs erstellen, exportieren und teilen.' : 'Create, export, and share PDF documents.',
      link: '/faq',
    },
    {
      icon: '👥',
      title: lang === 'de' ? 'Team & Business' : 'Team & Business',
      desc: lang === 'de' ? 'Team-Workspace einrichten und Benutzer verwalten.' : 'Set up your team workspace and manage users.',
      link: '/contact',
    },
  ];

  return (
    <>
      <Helmet>
        <title>{p.title} – Docudi</title>
        <meta name="description" content={p.sub} />
        <link rel="canonical" href="https://[YOUR-DOMAIN.com]/support" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content text-center">
            <div className="badge badge-gray">{p.title}</div>
            <h1 className="page-hero__title">{p.headline}</h1>
            <p className="page-hero__sub">{p.sub}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid-3" style={{ gap: 'var(--space-5)', marginBottom: 'var(--space-12)' }}>
            {SUPPORT_TOPICS.map((topic, i) => (
              <Link key={i} to={topic.link} className="card" style={{ display: 'block', textDecoration: 'none' }}>
                <div style={{ fontSize: '32px', marginBottom: 'var(--space-4)' }}>{topic.icon}</div>
                <h3 style={{ fontSize: 'var(--text-base)', fontWeight: 'var(--font-semibold)', marginBottom: 'var(--space-2)' }}>{topic.title}</h3>
                <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-500)', lineHeight: 'var(--leading-relaxed)' }}>{topic.desc}</p>
              </Link>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'var(--space-6)' }}>
            <div className="card" style={{ background: 'var(--color-primary-50)', border: '1px solid var(--color-primary-100)' }}>
              <h3 style={{ marginBottom: 'var(--space-2)' }}>📚 {lang === 'de' ? 'FAQ durchsuchen' : 'Browse FAQ'}</h3>
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--space-5)' }}>
                {lang === 'de' ? 'Antworten auf die häufigsten Fragen zu Docudi.' : 'Find answers to the most common questions about Docudi.'}
              </p>
              <Link to="/faq" className="btn btn-primary btn-sm">{t.faqPreview.viewAll}</Link>
            </div>
            <div className="card">
              <h3 style={{ marginBottom: 'var(--space-2)' }}>✉️ {lang === 'de' ? 'Support kontaktieren' : 'Contact Support'}</h3>
              <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-gray-600)', marginBottom: 'var(--space-5)' }}>
                {lang === 'de' ? 'Keine Antwort gefunden? Unser Team antwortet innerhalb von 24 Stunden.' : "Can't find your answer? Our team responds within 24 hours."}
              </p>
              <Link to="/contact" className="btn btn-secondary btn-sm">{t.faqPreview.contact}</Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
